import { Component, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent {

  @ViewChild(MenuComponent) menuComponent!: MenuComponent;


  @Input() menusArray: any[] = [];  // Full list of menus
  @Input() menus: any[] = [];       // Current level of menus

  expanded: Set<number> = new Set(); // Track expanded menus by index

  // Get nested menus based on parent index
  getNestedMenus(parentIndex: number): any[] {
    const nestedMenus = this.menusArray.filter(menu => menu.parent === parentIndex);
    return nestedMenus;
  }
  // Toggle expansion/collapse of a menu
  toggleMenu(index: number): void {
    if (this.isExpanded(index)) {
      this.expanded.delete(index);  // Collapse the menu
    } else {
      this.expanded.add(index);  // Expand the menu
    }
  }

  // Check if a menu is expanded
  isExpanded(index: number): boolean {
    return this.expanded.has(index);
  }

  // Track by menu ID to optimize rendering
  trackByMenuId(index: number, menu: any): number {
    return menu.index;
  }

  isNestedMenus(parentIndex: number): boolean {
    return this.menusArray.filter(menu => menu.parent === parentIndex).length > 0;
  }
  collapseAll(): void {
    this.expanded.clear();  // Collapse all menus
  }


  // Expand all menus by adding their indices to the expanded set
  expandAll(): void {
    // Add all top-level menu indices to the expanded set
    this.menus.forEach(menu => this.expanded.add(menu.index));
    // Recursively add indices of all nested menus
    this.menus.forEach(menu => this.addNestedMenuIndices(menu.index));
    if (this.menuComponent) {
      this.menuComponent.expandAll();
    } else {
      console.log("no child found ")
    }
  }

  // Recursively add nested menu indices
  private addNestedMenuIndices(parentIndex: number): void {
    const nestedMenus = this.getNestedMenus(parentIndex);
    nestedMenus.forEach(menu => {
      this.expanded.add(menu.index);
      this.addNestedMenuIndices(menu.index); // Recursion for nested menus
    });
  }


}